export const EVENT_INITIATORS = {
    USER: 'user',
    SYSTEM: 'system',
};

export const INTERACTION_TYPES = {
    CLICK: 'click',
    SCROLL: 'scroll',
    SELECT: 'select',
    TYPE: 'type',
    UPDATE: 'update',
    VIEW: 'view',
};

export const TARGETS = {
    ADDITIONAL_CRITERIA_DROPDOWN: 'Additional Criteria Dropdown',
    APPLY_FACET: 'ApplyFacet',
    AVAILABILITY_DROPDOWN: 'AvailabilityDropdown',
    BACK_TO_TOP_OF_PAGE: 'BackToTopOfPage',
    BOOK_ANYWAY: 'BookAnyway',
    BOOK_AN_APPOINTMENT: 'BookAnAppointment',
    BOOK_AN_APPOINTMENT_HEADER: 'BookAnAppointmentHeader',
    BREADCRUMB: 'Breadcrumb',
    BURGER_MENU: 'BurgerMenu',
    CHANGE_INSURANCE: 'ChangeInsurance',
    CHECK_INSURANCE_MODAL: 'CheckInsuranceModal',
    CHECK_INSURANCE_MODAL_CLOSE_ICON: 'CheckInsuranceModalCloseIcon',
    CHECK_MY_INSURANCE_BUTTON: 'CheckMyInsuranceButton',
    CAREERS_BUTTON: 'CareersButton',
    CAREERS_PANEL: 'CareersPanel',
    CLEAR_FACET: 'ClearFacet',
    DATA_PROVIDED_BY: 'DataProvidedBy',
    DOCTORS_EMAIL_TEXTBOX: 'DoctorsEmailTextbox',
    EXISTING_PATIENT: 'ExistingPatient',
    FACETED_SEARCH: 'FacetedSearch',
    FACET: 'Facet',
    FACET_CHIP: 'FacetChip',
    FACET_OPTION: 'FacetOption',
    FIND_A_DOCTOR_BY: 'FindADoctorBy',
    FIND_SIMILAR_DOCTORS_BUTTON: 'FindSimilarDoctorsButton',
    FIRST_NAME_TEXTBOX: 'FirstNameTextbox',
    GENDER: 'Gender',
    GENDER_FEMALE_FILTER: 'FemaleFilter',
    GENDER_MALE_FILTER: 'MaleFilter',
    GET_ZOCDOC_APP_PANEL: 'GetZocdocAppPanel',
    HOSPITAL_AFFILIATIONS_DROPDOWN: 'HospitalAffiliationsDropdown',
    I_BUBBLE: 'IBubble',
    INFO: 'Info',
    INFO_DOCTOR_CARD: 'DoctorCard',
    INSURANCE_OUT_OF_NETWORK_MODAL: 'InsuranceOutOfNetworkModal',
    INVITE_DOCTOR_FORM: 'InviteDoctorForm',
    INVITE_DOCTOR_FORM_FIND_ANOTHER_DOCTOR_BUTTON: 'InviteDoctorFormFindAnotherDoctorButton',
    INVITE_DOCTOR_FORM_SEND_BUTTON: 'InviteDoctorFormSendButton',
    INVITE_DOCTOR_FORM_FIND_AVAILABLE_DOCTORS_BUTTON: 'InviteDoctorFormFindAvailableDoctorsNearYouButton',
    INVITE_DOCTOR_FORM_CLAIM_THIS_PROFILE: 'InviteDoctorFormClaimThisProfile',
    IN_NETWORK_INSURANCES: 'InNetworkInsurances',
    JOIN_LINK: 'JoinLink',
    JOIN_PARTNERS_PANEL: 'JoinPartnersPanel',
    JOIN_PARTNERS_CTALINK: 'CTALink',
    KNOWLEDGE_BASE_FOOTER: 'KnowledgeBaseFooter',
    LAST_NAME_TEXTBOX: 'LastNameTextbox',
    LEGAL_FOOTER: 'LegalFooter',
    LINK: 'Link',
    LIST_PRACTICE_PANEL: 'ListYourPracticePanel',
    LIST_PRACTICE_CTALINK: 'CTALink',
    LANGUAGE_DROPDOWN: 'LanguageDropdown',
    LOCATION_CARD: 'LocationCard',
    LOCATION_CAROUSEL: 'LocationCarousel',
    LOCATION_CAROUSEL_INSURANCE_STATUS: 'InsuranceStatus',
    LOCATION_CAROUSEL_LEFT_ARROW: 'LeftArrow',
    LOCATION_CAROUSEL_MAP: 'Map',
    LOCATION_CAROUSEL_RIGHT_ARROW: 'RightArrow',
    LOCATION_LIST: 'LocationList',
    MAP: 'Map',
    MOBILE_MAP_TOGGLE: 'MobileMapToggle',
    MOBILE_HEADER_VIEW_MAP: 'MobileHeaderViewMap',
    MORE_FILTERS_BUTTON: 'MoreFiltersButton',
    MORE_FILTERS_DROPDOWN: 'MoreFiltersDropdown',
    NAME_CARD: 'NameCard',
    NEW_EXISTING_PATIENT_TYPE_RADIO: 'NewExistingPatientTypeRadio',
    NEW_PATIENT: 'NewPatient',
    NOTIFICATION_DROPDOWN: 'NotificationDropdown',
    NOTIFICATIONS: 'Notifications',
    PAGE_HEADER: 'PageHeader',
    PAGE_HEADER_LOGO: 'Logo',
    PAGE_HEADER_CTA_LINK: 'CTALink',
    PAGE_HEADER_LIST_YOUR_PRACTICE: 'ListYourPractice',
    PAGE_HEADER_RIGHT_CONTENT_CUSTOM_LINK: 'RightContentCustomLink',
    PAGE_NUMBER: 'PageNumber',
    PAGE_NUMBER_PAGE_NUMBER: 'PageNumber',
    PAGINATION: 'Pagination',
    PATIENT_KNOWLEDGE_BASE: 'PatientKnowledgeBase',
    PATIENT_POWERED_SEARCH: 'PatientPoweredSearch',
    PATIENT_POWERED_SEARCH_SEARCH_AUTOCOMPLETE_TERM: 'SearchAutocompleteTerm',
    PATIENT_POWERED_SEARCH_SEARCH_FIELD: 'SearchField',
    PATIENT_POWERED_SEARCH_SEARCH_QUERY: 'SearchQuery',
    PATIENT_REVIEWS: 'PatientReviews',
    PICTURE_GALLERY: 'PictureGallery',
    PRACTICE_ADDRESS: 'PracticeAddress',
    PRACTICE_INFORMATION: 'PracticeInformation',
    PRACTICE_STATEMENT: 'PracticeStatement',
    PROFESSIONAL_STATEMENT: 'ProfessionalStatement',
    PROFILE: 'Profile',
    PROFILE_HEADER_NAME_CARD: 'HeaderNameCard',
    PROFILE_HEADER_REVIEW_LINK: 'ReviewLink',
    PROFILE_HEADER_REVIEW_STARS: 'ReviewStars',
    PROFILE_MAP_LOCATION_CAROUSEL: 'ProfileMapLocationCarousel',
    PROFILE_NAME_CARD: 'NameCard',
    PROFILE_NAVIGATION: 'Navigation',
    PROFILE_NAVIGATION_TABS: 'Tabs',
    PROFILE_NAVIGATION_PROFILE_TAB: 'ProfileTab',
    PROFILE_NAVIGATION_REVIEWS_TAB: 'ReviewsTab',
    PROFILE_PROVIDER_PICTURE: 'ProviderPicture',
    PROFILE_PROVIDER_PICTURE_FRAME: 'ProviderPictureFrame',
    PROFILE_ADDITIONAL_PICTURE_CAPTION_LINK: 'AdditionalPictureCaptionLink',
    PROVIDER_AVAILABILITY_TOOLTIP: 'ProviderAvailabilityTooltip',
    REFINE_SEARCH_RESULTS: 'RefineSearchResults',
    REFINE_SEARCH_RESULTS_GENDER_DROPDOWN: 'RefineSearchGenderDropdown',
    REFINE_SEARCH_RESULTS_VISIT_REASON: 'VisitReason',
    REFINE_SEARCH_RESULTS_VISIT_REASON_DROPDOWN: 'VisitReasonDropdown',
    REFINE_SEARCH_RESULTS_VISIT_REASON_NEW_VISIT_REASON: 'NewVisitReason',
    REFINE_SEARCH_RESULTS_SPECIALTY: 'Specialty',
    REFINE_SEARCH_RESULTS_SPECIALTY_DROPDOWN: 'SpecialtyDropdown',
    REFINE_SEARCH_RESULTS_SPECIALTY_NEW_SPECIALTY: 'NewSpecialty',
    RELATED_LINKS: 'RelatedLinks',
    SEARCH_BAR: 'SearchBar',
    SEARCH_BUTTON: 'SearchButton',
    SEARCH_BUTTON_SEARCH_SUBMIT_BUTTON: 'SearchSubmitButton',
    SEARCH_RESULTS: 'SEARCH_RESULTS',
    SEARCH_RESULTS_CARD: 'SearchResultsCard',
    SEE_ALL_NOTIFICATIONS: 'SeeAllNotifications',
    SERVICE_BANNER: 'ServiceBanner',
    SERVICE_EMAIL: 'ServiceEmail',
    SERVICE_PHONE: 'ServicePhone',
    SHOW_MORE_REVIEWS: 'ShowMoreReviews',
    SHOW_MORE: 'ShowMore',
    SIGN_IN_LINK: 'SignInLink',
    SIGN_IN_DROPDOWN: 'SignInDropdown',
    SIGN_IN_DROPDOWN_LINK: 'SignInDropdownLink',
    SIGN_IN_DROPDOWN_PROVIDER_LOGIN: 'ProviderLoginLink',
    SIGN_IN_DROPDOWN_PATIENT_LOGIN: 'PatientLoginLink',
    SORT_MATCHES_DROPDOWN: 'SortMatchesDropdown',
    SPECIAL_HOURS_DROPDOWN: 'SpecialHoursDropdown',
    SPECIALTIES: 'Specialties',
    TELEHEALTH_MODAL: 'TelehealthModal',
    TELEHEALTH_MODAL_CLOSE: 'TelehealthModalClose',
    TELEHEALTH_DOWNLOAD_BUTTON: 'TelehealthDownloadButton',
    TELEHEALTH_PHONE_NUMBER_INPUT: 'TelehealthPhoneNumberInput',
    TELEHEALTH_SEND_SMS_BUTTON: 'TelehealthSendSmsButton',
    TELEHEALTH_SEND_SMS_FAILURE: 'TelehealthSendSmsFailure',
    TELEHEALTH_SEND_SMS_SUCCESS: 'TelehealthSendSmsSuccess',
    TELEHEALTH_RESULT: 'TelehealthResult',
    TELEHEALTH_PROFILE: 'TelehealthProfile',
    TELEHEALTH_PROVIDER: 'TelehealthProvider',
    TELEHEALTH_BOOKING_SIDEBAR: 'TelehealthBookingSidebar',
    TELEHEALTH_DOWNLOAD_FOOTER: 'TelehealthDownloadFooter',
    TELEHEALTH_ONLINE_INDICATOR: 'TelehealthOnlineIndicator',
    TELEHEALTH_OFFLINE_INDICATOR: 'TelehealthOfflineIndicator',
    TEXT_ME_THE_APP: 'TextMeTheApp',
    TEXT_ME_THE_APP_SEND_BUTTON: 'TextMe',
    THEMED_SEARCH: 'ThemedSearch',
    TIMESGRID: 'Timesgrid',
    TIMESGRID_MORE_TIMES: 'MoreTimes',
    TIMESGRID_NEXT_AVAILABLE: 'NextAvailable',
    TIMESGRID_NEXT_DAYS_ARROW: 'NextDaysArrow',
    TIMESGRID_NO_AVAILABILITY: 'NoAvailability',
    TIMESGRID_PREV_DAYS_ARROW: 'PreviousDaysArrow',
    TIMESGRID_PROVIDER_PHONE: 'ProviderPhone',
    TIMESGRID_TIMESLOT: 'Timeslot',
    UPCOMING_APPOINTMENTS: 'UpcomingAppointments',
    USERNAME_DROPDOWN: 'UserNameDropdown',
    USERNAME_DROPDOWN_MEDICAL_TEAM: 'MedicalTeam',
    USERNAME_DROPDOWN_PAST_APPOINTMENTS: 'PastAppointments',
    USERNAME_DROPDOWN_SETTINGS: 'Settings',
    USERNAME_DROPDOWN_SIGN_OUT: 'SignOut',
    UNIVERSAL_SEARCH_HEADER: 'UniversalSearchHeader',
    VIEW_ALL_ACCEPTED_INSURANCES: 'ViewAllAcceptedInsurances',
    VIEW_ALL_IN_NETWORK_INSURANCES: 'ViewAllInNetworkInsurances',
    VIEW_ALL_LOCATIONS: 'ViewAllLocations',
    VIEW_ALL_SPECIALTIES: 'ViewAllSpecialties',
    VIEW_MORE_INFO: 'ViewMoreInfo',
    VISIT_REASON: 'VisitReasonDropdown',
    VISIT_REASON_DROPDOWN: 'VisitReasonDropdown',
    ZOCDOC_FOOTER: 'ZocdocFooter',
    ZOCDOC_RECOGNITION: 'ZocdocRecognition',
};

export const EVENT_ACTION = {
    CLICK_PROVIDER_PICTURE: 'Click Provider Picture',
    CLICK_ADDITIONAL_PICTURE_CAPTION_LINK: 'Click Additional Picture Caption Link',
};
